import { render, staticRenderFns } from "./Fetching.vue?vue&type=template&id=6c0252c6&scoped=true"
import script from "./Fetching.vue?vue&type=script&lang=js"
export * from "./Fetching.vue?vue&type=script&lang=js"
import style0 from "./Fetching.vue?vue&type=style&index=0&id=6c0252c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0252c6",
  null
  
)

export default component.exports